<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homes' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/Stay' }" replace>待做作业</el-breadcrumb-item>
				<el-breadcrumb-item>答题</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div id="time" class="time_box p_m_t_30 p_flex p_f_b p_f_a">
			<div class="p_flex type_size_20 p_f_a">
				<span class="el-icon-time"></span>
				<span class="type_size_18 p_m_l_20">{{ chronoscope }}</span>
			</div>
			<el-button type="success" @click="onSubmit()">提交</el-button>
		</div>
		<div class="overflow p_flex" :style="{ height: height + 'px' }">
			<div class="p_f_3 " v-if="Info.exercise_book_file_type">
				<div style="width: 100%;height: 100%;" v-if="Info.exercise_book_file_type == 1"><view-iform :url="Info.exercise_book_file_url"></view-iform></div>
				<div style="width: 100%;height: 100%;" v-if="Info.exercise_book_file_type == 2">
					<view-iform :url="'https://view.officeapps.live.com/op/view.aspx?src=' + Info.exercise_book_file_url"></view-iform>
				</div>
				<div style="width: 100%;height: 100%;" class="overflow" v-if="Info.exercise_book_file_type == 3">
					<view-picture :url="Info.exercise_book_file_url"></view-picture>
				</div>
			</div>
			<div class="p_f_2 p_m_l_20 deatbox overflow">
				<div class="deat_boxs" v-for="(item, index) in InfoList" :key="index">
					<div class="p_flex p_f_a ">
						<el-tag type="success" size="small " effect="dark">{{ item.question_type | questionType }}</el-tag>
						<span class="type_size_18 p_m_l_20">{{ index + 1 }}.</span>
						<span class="type_size_18 p_m_l_10">分值({{ item.score }}分)</span>
					</div>
					<!-- 单选 -->
					<div v-if="item.question_type == 1">
						<div class="p_flex p_m_t_20">
							<div class="p_m_r_20" v-for="(val, key) in item.affiliation" :key="key">
								<el-radio :label="val.name" v-model="answer[index].content" class="p_flex">
									<p class="p_flex" style="font-size: 20px;">{{ val.name }}</p>
								</el-radio>
							</div>
						</div>
					</div>
					<!-- 多选 -->
					<div v-if="item.question_type == 2">
						<div class="p_flex p_m_t_20">
							<div class="p_m_r_20" v-for="(val, key) in item.affiliation" :key="key">
								<el-checkbox :label="val.name" v-model="answer[index].content" class="p_flex">
									<p class="p_flex" style="font-size: 20px;">{{ val.name }}</p>
								</el-checkbox>
							</div>
						</div>
					</div>
					<!-- 判断 -->
					<div v-if="item.question_type == 3">
						<div class="p_m_t_20">
							<el-radio label="A" v-model="answer[index].content">对</el-radio>
							<el-radio label="B" v-model="answer[index].content">错</el-radio>
						</div>
					</div>
					<!-- 填空 -->
					<div v-if="item.question_type == 4">
						<div style="margin-top: 10px;">
							<div class="p_f_1  type_size_18 ">
								<el-input
									style="margin-top: 10px"
									v-for="(val, key) in answer[index].content"
									:key="key"
									type="text"
									v-model="answer[index].content[key].text"
									placeholder="请输入答案"
								>
									<template slot="prepend">
										{{ val.name }}、
									</template>
								</el-input>
							</div>
						</div>
						<div class="upload-image" v-if="item.answer_mode == 2 || item.answer_mode == 3">
							<div class="image-item" v-for="(val, key) in answer[index].image" :key="key">
								<el-image style="width: 90px; height: 90px;" :src="val" :preview-src-list="answer[index].image" />
								<span class="del-image" @click.stop="delImage(index, key, val)">×</span>
							</div>
							<el-upload
								style="width: 90px; height: 90px;margin-top: 10px;"
								:data="{ index }"
								:action="$request.ajaxUrl + '/Upload/image/type/student'"
								:headers="$request.headers(true)"
								:show-file-list="false"
								list-type="picture-card"
								:multiple="false"
								:on-success="uploadImage"
							>
								<i class="el-icon-plus"></i>
							</el-upload>
						</div>
					</div>
					<!-- 问答 -->
					<div v-if="item.question_type == 5">
						<div class="p_m_t_20">
							<div class="p_f_1 type_size_18  ">
								<el-input
									type="textarea"
									v-if="item.answer_mode == 1 || item.answer_mode == 3"
									:autosize="{ minRows: 4 }"
									v-model="answer[index].content"
									placeholder="请输入答案"
								></el-input>
							</div>
						</div>
						<div class="upload-image p_m_t_20" v-if="item.answer_mode == 2 || item.answer_mode == 3">
							<div class="image-item" v-for="(val, key) in answer[index].image" :key="key">
								<el-image style="width: 90px; height: 90px;" :src="val" :preview-src-list="answer[index].image" />
								<span class="del-image" @click.stop="delImage(index, key, val)">×</span>
							</div>
							<el-upload
								style="width: 90px; height: 90px;margin-top: 10px;"
								:data="{ index }"
								:action="$request.ajaxUrl + '/Upload/image/type/student'"
								:headers="$request.headers(true)"
								:show-file-list="false"
								list-type="picture-card"
								:multiple="false"
								:on-success="uploadImage"
							>
								<i class="el-icon-plus"></i>
							</el-upload>
						</div>
					</div>
					<!-- 材料 -->
					<div v-if="item.question_type == 6">
						<div id="">
							<div v-for="(val, key) in item.affiliation" :key="key" style="margin: 15px; 0">
								<div style="font-size: 16px; line-height: 30px;" v-html="val.name"></div>
								<div style="margin: 10px 0; color: #000000; padding-left: 30px; box-sizing: border-box;" v-if="item.answer_mode == 1 || item.answer_mode == 3">
									<el-input type="text" v-model="answer[index].content[key].text" placeholder="请输入答案">
										<template slot="prepend">
											答：
										</template>
									</el-input>
								</div>
							</div>
							<div class="upload-image p_m_t_20" v-if="item.answer_mode == 2 || item.answer_mode == 3">
								<div class="image-item" v-for="(val, key) in answer[index].image" :key="key">
									<el-image style="width: 90px; height: 90px;" :src="val" :preview-src-list="answer[index].image" />
									<span class="del-image" @click.stop="delImage(index, key, val)">×</span>
								</div>
								<el-upload
									style="width: 90px; height: 90px;margin-top: 10px;"
									:data="{ index }"
									:action="$request.ajaxUrl + '/Upload/image/type/student'"
									:headers="$request.headers(true)"
									:show-file-list="false"
									list-type="picture-card"
									:multiple="false"
									:on-success="uploadImage"
								>
									<i class="el-icon-plus"></i>
								</el-upload>
							</div>
						</div>
					</div>
					<div v-if="show" class="p_m_t_20 type_size_16">解析：{{ item.analysis }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ViewIform from './commponents/iform.vue';
import ViewPicture from './commponents/picture.vue';
export default {
	components: {
		ViewIform,
		ViewPicture
	},
	data() {
		return {
			height: 0,
			radio: 0,
			chronoscope: '00:00',
			jobPublishId: '',
			jobSsubmitId: '',
			Info: {},
			InfoList: {},
			answer: [],
			show: false
		};
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/AnswerSheets') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	filters: {
		questionType(val) {
			if (val == 1) {
				return '单选题';
			}
			if (val == 2) {
				return '多选题';
			}
			if (val == 3) {
				return '判断题';
			}
			if (val == 4) {
				return '填空题';
			}
			if (val == 5) {
				return '问答题';
			}
			if (val == 6) {
				return '材料题';
			}
		}
	},
	mounted() {
		var jobPublishId = parseInt(this.$route.query.jobPublishId);
		this.jobPublishId = jobPublishId;
		this.indexInfo();
		this.deatilInfo();
	},
	methods: {
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var time = document.getElementById('time').offsetHeight;
			var height = box - head - time - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		deatilInfo() {
			var data = {};
			data.job_publish_id = this.jobPublishId;
			this.$request
				.ajax(this)
				.post('api_student/start_answer', data)
				.then(res => {
					this.hms(res.data.service_time, res.data.start_time);
					if (res.data.service_time > res.data.submit_time) {
						this.show = true;
					} else {
						this.show = false;
					}
					this.cardDetail(res.data.question_id, res.data.job_submit_id);
				})
				.catch(res => {
					this.$router.back();
				});
		},
		cardDetail(id, job) {
			var data = {};
			data.job_publish_id = this.jobPublishId;
			data.job_submit_id = job;
			this.$request
				.ajax(this)
				.post('api_student/exercise_answer_card_question_list', data)
				.then(res => {
					console.log(res);
					this.Info = res.data.job_publish;
					if (res.data.list.length != 0) {
						this.InfoList = res.data.list;
						this.cardDetails(res.data.list);
					}
				})
				.catch(res => {
					this.$router.back();
				});
		},
		cardDetails(e) {
			var answer = [];
			e.forEach((item, index) => {
				var temp = { question_id: item.id, image: [] };
				if (item.job_record) {
					temp.answer_format = item.job_record.answer_format;

					if (item.job_record.image) {
						temp.image = item.job_record.image;
					}
					if (item.question_type == 2) {
						temp.content = [];
						var content = item.job_record.content;
						for (let i = 0; i < str.length; i++) {
							temp.content.push(content[i]);
						}
					} else {
						temp.content = item.job_record.content;
					}
				} else {
					if (item.question_type == 1 || item.question_type == 2 || item.question_type == 3 || item.question_type == 5) {
						temp.answer_format = 'text';
						if (item.question_type == 2) {
							temp.content = [];
						} else {
							temp.content = '';
						}
					} else {
						temp.answer_format = 'json';
						temp.content = [];
						item.affiliation.forEach((v, k) => {
							temp.content.push({ name: v.name, text: '' });
						});
					}
				}
				answer.push(temp);
			});
			this.answer = answer;
		},
		uploadImage(e) {
			this.answer[parseInt(e.data.index)].image.push(e.data.file);
		},
		delImage(index, key, val) {
			var _this = this;
			this.$confirm('是否确认删除此图片?', '提示', {
				confirmButtonText: '删除',
				cancelButtonText: '返回',
				type: 'warning'
			}).then(() => {
				var image = _this.answer[index].image;
				var newImage = [];
				image.forEach((v, k) => {
					if (val != v) {
						newImage.push(v);
					}
				});
				_this.answer[index].image = newImage;
			});
		},
		onSubmit() {
			var answer = [];
			var question = this.InfoList;
			// 处理多选题
			for (let i = 0; i < question.length; i++) {
				var temp = { answer_format: this.answer[i].answer_format, image: this.answer[i].image, question_id: question[i].id };
				if (question[i].question_type == 2) {
					var str = '';
					this.answer[i].content.forEach(v => {
						str += v;
					});
					temp.content = str;
				} else {
					temp.content = this.answer[i].content;
				}
				answer.push(temp);
			}
			console.log(answer);
			var tips = this.checkAnswer(question, answer);

			if (tips.length > 0) return this.$message.info(tips);

			var _this = this;
			this.$request
				.ajax(this)
				.post('api_student/exercise_batch_answer', { job_publish_id: this.jobPublishId, answer })
				.then(res => {
					this.$alert('作业提交成功，请等待老师批改', '提示', {
						confirmButtonText: '确定',
						callback: action => {
							this.$router.back();
						}
					});
				});
		},
		checkAnswer(question, answer) {
			var tips = '';
			for (var index = 0; index < question.length; index++) {
				var item = question[index];
				if (item.answer_mode == 1) {
					if (answer[index].answer_format == 'json') {
						for (var key = 0; key < answer[index].content.length; key++) {
							if (!answer[index].content[key].text) {
								tips = '请将题目' + (index + 1) + '答案填写完整后提交';
								break;
							}
						}
					} else {
						if (!answer[index].content) {
							tips = '请将题目' + (index + 1) + '答案填写完整后提交';
							break;
						}
					}
				} else if (item.answer_mode == 2) {
					if (!answer[index].image || answer[index].image.length == 0) {
						tips = '请将题目' + (index + 1) + '答案填写完整后提交';
						break;
					}
				} else {
					var flag = false;
					if (answer[index].answer_format == 'json') {
						for (var key = 0; key < answer[index].content.length; key++) {
							if (!answer[index].content[key].text) {
								flag = true;
							}
						}
					} else {
						if (!answer[index].content) {
							flag = true;
						}
					}
					if (flag && (!answer[index].image || answer[index].image.length == 0)) {
						tips = '请将题目' + (index + 1) + '答案填写完整后提交';
						break;
					}
				}
			}
			return tips;
		},
		hms(thisTime, startTime) {
			var _this = this;
			let result = parseInt(thisTime - startTime);
			let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
			let m = Math.floor((result / 60) % 60) < 10 ? '0' + Math.floor((result / 60) % 60) : Math.floor((result / 60) % 60);
			let s = Math.floor(result % 60) < 10 ? '0' + Math.floor(result % 60) : Math.floor(result % 60);
			let res = '';
			if (h !== '00') res += `${h}:`;
			if (m !== '00') res += `${m}:`;
			res += `${s}`;
			_this.chronoscope = res;
			setTimeout(function() {
				_this.hms(thisTime + 1, startTime);
			}, 1000);
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	}
};
</script>

<style lang="scss" scoped>
.p_f_2 {
	flex: 2;
}
.p_f_3 {
	flex: 3;
}
.mine_header {
	background-color: #fafafa;
	height: 60px;
}

.header_left > div {
	height: 100%;
	position: relative;
	margin-left: 260px;
}

.header_left > div:nth-child(2) {
	margin-left: 50px;
}

.header_left {
	height: 100%;
}
.time_box {
	background: #fafafa;
	padding: 15px 60px;
}
.deatbox {
	padding: 0 20px;
	background-color: #ffffff;
}

.deat_boxs {
	padding: 20px;
	border-bottom: 1px solid #e6e6e6;
}
.radio > div {
	display: flex;
}
// 单选
>>> .el-radio__input.is-checked .el-radio__inner {
	border-color: #00af63;
	background: #00af63;
}
>>> .el-radio__input.is-checked + .el-radio__label {
	color: #00af63;
}
>>> .el-radio__inner {
	width: 20px;
	height: 20px;
}
>>> .el-radio__label {
	font-size: 20px;
}
>>> .el-radio__inner:hover {
	border-color: #999999;
}
>>> .el-radio__inner::after {
	width: 8px;
	height: 8px;
}
// 多选
>>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	border-color: #00af63;
	background: #00af63;
}
>>> .el-checkbox__input.is-checked + .el-checkbox__label {
	color: #00af63;
}
>>> .el-checkbox__inner {
	width: 20px;
	height: 20px;
}
>>> .el-checkbox__label {
	font-size: 18px;
}
>>> .el-checkbox__inner:hover {
	border-color: #999999;
}
>>> .el-checkbox__inner::after {
	height: 9px;
	left: 6px;
	top: 1px;
	width: 4px;
}
>>> .el-input__inner:focus {
	border-color: #00af63;
}
>>> .el-textarea__inner:focus {
	border-color: #00af63;
}
.upload-image {
	box-sizing: border-box;
	.image-item {
		width: 90px;
		height: 90px;
		position: relative;
		display: inline-block;
		margin: 5px;
		.del-image {
			position: absolute;
			width: 18px;
			height: 18px;
			line-height: 18px;
			text-align: center;
			border-radius: 50%;
			background-color: #f0f0f0;
			top: -5px;
			right: -5px;
			z-index: 10;
		}
	}
}
>>> .el-upload--picture-card {
	width: 90px;
	height: 90px;
	line-height: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/homes/stay/answer_sheet.vue